module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_10_1.03242160.jpg";